import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig } from 'src/app/app-config.loader';
import { NuovoDocumentoService } from 'src/app/core/nuovo-documento.service';
import { PosizioniService } from 'src/app/core/posizioni.service';
import { PosizioniEventType } from 'src/app/shared/components/add-position/add-position.component';
import { Posizione } from 'src/app/shared/models/posizione.model';
import { GestionePosizioniItem, GestionePosizioniTreeNode } from '../../gestione-posizioni.model';
import { GassClaims } from 'src/app/auth/gass-claims';

@Component({
  selector: 'app-gestione-posizioni-table',
  templateUrl: './gestione-posizioni-table.component.html',
  styleUrls: ['./gestione-posizioni-table.component.scss']
})
export class GestioneTableComponent implements OnChanges {
  @Input() treeChild!: Posizione[] | null;
  @Output() downloadAggregazioneXml = new EventEmitter<{ payload: GestionePosizioniItem }>();
  @Output() modifyNode = new EventEmitter<{ payload: GestionePosizioniItem, type: PosizioniEventType }>();
  @Output() moveNode = new EventEmitter<{ payload: GestionePosizioniItem }>();

  public allRows: GestionePosizioniTreeNode[] | undefined;
  public fascicoloLevel: number;
  public hierarchyLastLevel: number;

  public GassClaims = GassClaims;

  constructor(private readonly appConfig: AppConfig, private readonly router: Router, private readonly nuovoDocumentoService: NuovoDocumentoService, private readonly posizioniService: PosizioniService) {
    this.fascicoloLevel = this.appConfig.logic.hierarchy.descriptionIndex;
    this.hierarchyLastLevel = this.appConfig.logic.hierarchy.labels.length - 1;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.treeChild?.currentValue && (changes.treeChild.currentValue as Posizione[]).length > 0) {
      this.orderNodes(changes.treeChild.currentValue as Posizione[]);
    }
  }

  orderNodes(nodes: Posizione[]): void {
    const rootNode = {
      data: {
        posizioneId: '/',
        chiuso: false,
        dataApertura: new Date(0),
        level: -1,
        sigla: '',
      } as GestionePosizioniItem,
      children: [] as GestionePosizioniTreeNode[],
    } as GestionePosizioniTreeNode;

    this.allRows = nodes
      .reduce((tree, posizione) => {
        const data = {
          ...posizione,
          orderString: this.posizioniService.calculateOrderString(posizione),
          level: posizione.posizioneId.split('/').length - 3,
        } as GestionePosizioniItem;

        const parentTreeNode = this.getParentTreeNode(tree, data.posizioneId);
        parentTreeNode?.children?.push(({
          data,
          children: []
        } as GestionePosizioniTreeNode));

        // Verifica se un livello superiore è chiuso
        let recursiveParent = parentTreeNode;
        while (recursiveParent && !data.chiuso) {
          data.chiuso = recursiveParent.data?.chiuso ?? false;
          recursiveParent = recursiveParent.parent;
        }

        return tree;
      }, ([rootNode] as GestionePosizioniTreeNode[]))[0].children;

    this.allRows?.sort((a, b) => {
      const aOrder = a.data?.orderString ?? '';
      const bOrder = b.data?.orderString ?? '';
      return aOrder > bOrder ? 1 : (aOrder < bOrder ? -1 : 0);
    });
  }

  modRow(node: GestionePosizioniItem): void {
    this.modifyNode.emit({ payload: node, type: 'mod' });
  }

  addInRow(node: GestionePosizioniItem): void {
    this.modifyNode.emit({ payload: node, type: 'add' });
  }


  moveNodePosition(node: GestionePosizioniItem): void {
    this.moveNode.emit({ payload: node });
  }

  downloadXml(node: GestionePosizioniItem): void {
    this.downloadAggregazioneXml.emit({ payload: node });
  }

  selectedDocument(e: { node: GestionePosizioniTreeNode }): void {
    const result: Posizione[] = [];
    let current: GestionePosizioniTreeNode | undefined = { ...e.node };
    if (current.data) {
      result.push(current.data);
    }

    while (current?.parent) {
      current = { ...current.parent };
      if (current.data) {
        result.push(current.data);
      }
    }

    result.reverse();
    this.nuovoDocumentoService.setPosizione(result);
    void this.router.navigate(['nuovo-in-fascicolo']);
  }

  sortChildren(e: { node: GestionePosizioniTreeNode }): void {
    e.node.children?.sort((a, b) => this.posizioniService.sortPosizioni(a.data!, b.data!));
  }

  private getParentTreeNode(elements: GestionePosizioniTreeNode[], posizioneId: string): GestionePosizioniTreeNode | undefined {
    let currentPos = '/';
    let result = elements.find(r => r.data?.posizioneId === currentPos);
    const splitPosition = posizioneId.split('/');
    for (let i = 1; i < splitPosition.length - 2; i++) {
      currentPos += `${splitPosition[i]}/`;
      const currentChild = result?.children?.find(r => r.data?.posizioneId === currentPos);
      if (!currentChild) {
        break;
      }

      result = currentChild;
    }

    return result;
  }
}
